<template>
	<div>
		<div>
          <subscription-recurring-change />
		</div>

	</div>
</template>

<script>
import SubscriptionRecurringChange from '../Checkout/SubscriptionRecurringChange'


export default {
	components: {
    	SubscriptionRecurringChange,
	}
}

</script>
